/**
 * Created by jv on 08/02/2018.
 */
//js
const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/language-manager");
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();

//Styles
require("Styles/pages/legal/cookie-policy.scss");

// Partial views
const htmlReq = require.context("Views/legal/partials", true, /cookie-policy\.html$/);

$(function()
{
  Shared.init();
  
  CookiePolicyPage.init();
});

var CookiePolicyPage = {};

((CookiePolicyPage) =>
{
  CookiePolicyPage.init = function()
  {
    setUpHtmlPartial();
  };

  function setUpHtmlPartial()
  {
    var htmlRequire = "./" + LanguageManager.getCurrentLocale() + "/cookie-policy.html";
    var htmlPartial;

    if($.inArray(htmlRequire, htmlReq.keys()) !== -1)
    {
      htmlPartial = htmlReq(htmlRequire);

      $("#cookie-policy-content").html(htmlPartial);
    }
    else
    {
      log.error("Couldn't find html partial [%s] in known html partial list: %o", htmlRequire, htmlReq.keys());
      utils.redirect("/");
    }
  }
})(CookiePolicyPage);



// WEBPACK FOOTER //
// ./app/js/entries/legal/cookie-policy.js